module.exports = __webpack_public_path__ + "64cb263f.svg";